import React from "react";
import BaseTooltip from "@reusables/BaseTooltip";
import { useTranslation } from "react-i18next";
import { Shield } from "lucide-react";

type ReservationsPresenceBadgeProps = {
    has_reservations: boolean;
}

export default function ReservationsPresenceBadge({ has_reservations }: ReservationsPresenceBadgeProps) {
   const {t} = useTranslation("", { keyPrefix: "sales.orders.main.table" });

   if (!has_reservations) {
       return null;
   }

   return (
       <BaseTooltip title={t("has_reservations") + "."} placement="top">
           <div
               className="inline-flex items-center rounded-xl px-2 p-1 border border-solid text-xs text-accent relative"
               style={{
                   backgroundColor: "#FBFBFB",
                   borderColor: "#E4E4E4",
               }}
           >
               <Shield className="text-[#A6DD4C]" size={14}/>
           </div>
       </BaseTooltip>
   )
}
